import { render, staticRenderFns } from "./BankDetails.vue?vue&type=template&id=22f534ea&scoped=true&"
import script from "./BankDetails.vue?vue&type=script&lang=js&"
export * from "./BankDetails.vue?vue&type=script&lang=js&"
import style0 from "./BankDetails.vue?vue&type=style&index=0&id=22f534ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f534ea",
  null
  
)

export default component.exports